import 'reflect-metadata';

export * as Core from '@dooboostore/core';
export * as CoreWeb from '@dooboostore/core-web';
export * as DomRender from '@dooboostore/dom-render';
export * as SimpleBoot from '@dooboostore/simple-boot';

export * from './component';
export * from './decorators';
export * from './lifecycle';
export * from './option';
export * from './script';
export * from './service';
export * from './throwable';
export * from './SimpleBootFront';
export * from './DomRenderRootObject';